import React, { useState } from "react";
import { Button, Typography, message } from "antd";
import orderService from "../../services/OrderLists";
import { useParams } from "react-router-dom";

const { Text } = Typography;

const MarkAsDraft = ({ handleModalClose, fetchOrderDetails }) => {
    const [loading, setLoading] = useState(false);
    const { orderKey } = useParams();

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const payload = {
                mark_as_draft: true,
            };
            const response = await orderService.markAsDraft(orderKey, payload);
            if (response.success) {
                message.success("Order marked as draft submission successfully!");
                fetchOrderDetails();
                handleModalClose();
            } else {
                message.error("Failed to mark order as draft.");
            }
        } catch (error) {
            console.error("Error marking as draft:", error);
            message.error("An error occurred while marking the order as draft.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: "0 10px 10px 10px" }}>
            <div style={{ marginBottom: "24px", textAlign: "left" }}>
                <Text style={{ fontSize: "16px" }}>
                    Are you sure you want to mark it as draft submission?
                </Text>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                }}
            >
                <Button onClick={handleModalClose} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    type="primary"
                    onClick={handleConfirm}
                    loading={loading}
                    danger
                >
                    Confirm
                </Button>
            </div>
        </div>
    );
};

export default MarkAsDraft;